import { TemperaturesCard } from "./TemperaturesCard";
export default TemperaturesCard;
